/* Picura Anfrage 2.0 – Schrittsteuerung, Steckbrief, Richtwert, Empfehlung, Versand.
   Gemeinsame Technik (Versand, Herkunft, Tracking, Rückruf) liegt in
   assets/picura-form-core.js; die Section bindet beide als defer ein, der
   Kern läuft also zuerst. Ohne JavaScript bleiben alle Schritte sichtbar.

   Schritte tragen Namen statt Nummern (anlass, bedarf, details, rahmen, kontakt) —
   der Branchen-Check und der Produktmodus lassen unterschiedliche weg. */
(function () {
  'use strict';
  /* Steht die Section zweimal auf einer Seite, läuft die Datei zweimal —
     die globalen Klick-Handler sollen trotzdem nur einmal hängen. */
  if (window.__picuraAnfrageJs) return;
  window.__picuraAnfrageJs = true;

  function alle(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function zahl(n) { return Number(n).toLocaleString('de-DE'); }
  function spanne(von, bis) {
    if (!von) return '';
    return bis > von ? 'ca. ' + zahl(von) + '–' + zahl(bis) + ' €' : 'ab ' + zahl(von) + ' €';
  }

  function init(root) {
    if (root.dataset.paReady) return;
    root.dataset.paReady = '1';

    var core = window.PicuraForm || null;
    var cfg = {};
    try { cfg = JSON.parse(root.querySelector('[data-pa-config]').textContent); } catch (e) { cfg = {}; }
    var check = cfg.modus === 'branchen_check';
    var form = root.querySelector('.pa__form');
    var steps = alle('.pa__step', root);
    if (!form || !steps.length) return;
    root.classList.add('is-js');

    var sektion = root.closest('.picura-anfrage');
    var anker = sektion ? sektion.querySelector('.pa-anchor') : null;
    var el = {
      status: root.querySelector('[data-pa-status]'),
      bars: root.querySelector('[data-pa-bars]'),
      back: root.querySelector('[data-pa-back]'),
      next: root.querySelector('[data-pa-next]'),
      submit: root.querySelector('[data-pa-submit]'),
      msg: root.querySelector('[data-pa-msg]'),
      uebersicht: root.querySelector('[data-pa-uebersicht]'),
      richtwertBox: root.querySelector('[data-pa-richtwert-box]'),
      richtwert: root.querySelector('[data-pa-richtwert]'),
      empfehlung: root.querySelector('[data-pa-empfehlung]'),
      done: root.querySelector('.pa__done'),
      iframe: root.querySelector('iframe'),
      zeitfenster: root.querySelector('[data-pa-zeitfenster]'),
      datum: root.querySelector('[data-pa-datum]'),
      vorschlag: root.querySelector('[data-pa-vorschlag]'),
      kontaktFehler: root.querySelector('[data-pa-kontakt-error]')
    };
    var storeKey = 'picura-anfrage:' + (cfg.storageKey || 'default');
    var formId = check ? 'branchen_check' : (cfg.productMode ? 'produkt' : 'projekt');
    var index = 0, ersteEingabe = 0, gestartet = false, letzterZeiger = 0, aktuelleId = '';

    /* ---------- Lesen ---------- */
    function gewaehlt() { return alle('[data-pa-need]', form).filter(function (x) { return x.checked; }); }
    function anlass() { return alle('[data-pa-anlass]', form).filter(function (x) { return x.checked; })[0] || null; }
    function feld(name) { var f = form.querySelector('[name="' + name + '"]'); return f ? f : null; }
    function wert(name) {
      var f = alle('[name="' + name + '"]', form);
      if (!f.length) return '';
      if (f[0].type === 'radio' || f[0].type === 'checkbox') return f.filter(function (x) { return x.checked && !x.disabled; }).map(function (x) { return x.value; }).join(', ');
      return (f[0].value || '').trim();
    }
    function wunschweg() { return wert('feld_wunschweg') || 'E-Mail'; }
    /* Straße, PLZ und Ort als eine Zeile, z. B. „Hauptstr. 1, 53111 Bonn“ */
    function adresse() {
      var ort = [wert('plz'), wert('ort')].filter(Boolean).join(' ');
      return [wert('strasse'), ort].filter(Boolean).join(', ');
    }
    function nurAnderes() {
      var keys = gewaehlt().map(function (x) { return x.dataset.paKey; });
      return keys.length === 1 && keys[0] === 'anderes';
    }
    function preisSumme() {
      var von = 0, bis = 0, unbekannt = false;
      gewaehlt().forEach(function (x) {
        var v = parseFloat(x.dataset.paVon) || 0, b = parseFloat(x.dataset.paBis) || 0;
        if (!v) { unbekannt = true; return; }
        von += v; bis += Math.max(b, v);
      });
      return { von: von, bis: bis, unbekannt: unbekannt };
    }

    /* ---------- Details nur für gewählte Bereiche ---------- */
    function syncDetails() {
      var aktiv = gewaehlt().map(function (x) { return x.dataset.paKey || x.value; });
      var sichtbar = 0;
      alle('[data-pa-for]', form).forEach(function (g) {
        var an = aktiv.indexOf(g.dataset.paFor) > -1;
        g.hidden = !an;
        alle('input, textarea, select', g).forEach(function (f) { f.disabled = !an; });
        if (an) sichtbar++;
      });
      var leer = root.querySelector('[data-pa-details-empty]');
      if (leer) leer.hidden = sichtbar > 0;
      return sichtbar;
    }
    /* ---------- Aufklapp-Bereiche im Detailschritt ----------
       Offen/zu nur per Klasse – die Felder bleiben im Formular, Angaben gehen
       beim Schließen nicht verloren. Geschlossen zeigt die Kopfzeile eine Kurzinfo. */
    function accZaehle(acc) {
      var n = 0, notiz = false;
      alle('[data-pa-extra]', acc).forEach(function (f) {
        if (f.hasAttribute('data-pa-notiz')) { notiz = !!f.value.trim(); return; }
        if (f.type === 'radio' || f.type === 'checkbox') { if (f.checked) n++; }
        else if (f.value.trim()) n++;
      });
      return { n: n, notiz: notiz };
    }
    function detailsLeer() {
      return !alle('[data-pa-acc]', form).some(function (a) { var z = accZaehle(a); return !a.hidden && (z.n || z.notiz); });
    }
    /* Schritt 3: zugeklappt steht die Auswahl selbst in der Kopfzeile */
    function klappInfo(acc, out) {
      var werte = [];
      alle('input, textarea', acc).forEach(function (f) {
        if (f.type === 'radio' || f.type === 'checkbox') { if (f.checked) werte.push(f.value); return; }
        var v = (f.value || '').trim(); if (!v) return;
        if (f.type === 'date') werte.push(v.split('-').reverse().join('.'));
        else if (f.tagName === 'TEXTAREA') werte.push(v.length > 40 ? v.slice(0, 40) + ' …' : v);
        else werte.push(v);
      });
      out.textContent = werte.length ? werte.join(', ') : (out.dataset.leer || '');
    }
    function klappVon(x) { return x.closest('[data-pa-acc], [data-pa-klapp]'); }
    function klappInhalt(acc) {
      return alle('input, textarea', acc).some(function (f) {
        return (f.type === 'radio' || f.type === 'checkbox') ? f.checked : !!(f.value || '').trim();
      });
    }
    /* Schritt 3: grün = Inhalt vorhanden, orange = ohne Eingabe übersprungen.
       Erst wenn alle grün sind, ist „Weiter“ des Schritts klickbar. */
    function rahmenKlapps() { var st = steps[stepIndex('rahmen')]; return st ? alle('[data-pa-klapp]', st) : []; }
    function rahmenStand() {
      var alleGruen = true;
      rahmenKlapps().forEach(function (a) {
        var inhalt = klappInhalt(a), fertig = a.classList.contains('is-fertig');
        a.classList.toggle('is-gruen', inhalt);
        a.classList.toggle('is-uebersprungen', fertig && !inhalt);
        if (!inhalt && !fertig) alleGruen = false;
        var b = a.querySelector('[data-pa-klapp-weiter]');
        if (b) { b.textContent = inhalt ? b.dataset.weiter : b.dataset.skip; b.classList.toggle('is-skip', !inhalt); }
      });
      var aufRahmen = steps[index] && steps[index].dataset.paStep === 'rahmen';
      if (el.next && aufRahmen) el.next.disabled = !alleGruen;
      /* Kleiner Link neben dem gesperrten Weiter: alles Offene auf einmal überspringen */
      var sk = root.querySelector('[data-pa-rahmen-skip]');
      if (sk) sk.hidden = !(aufRahmen && !alleGruen);
    }
    function klappWeiter(acc) {
      acc.classList.add('is-fertig');
      accSetze(acc, false);
      var liste = rahmenKlapps(), naechster = liste[liste.indexOf(acc) + 1];
      if (naechster) {
        accSetze(naechster, true);
        var kopf = naechster.querySelector('[data-pa-acc-toggle]');
        if (kopf) kopf.focus({ preventScroll: true });
        if (naechster.scrollIntoView) naechster.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
      rahmenStand();
    }
    function accInfo(acc) {
      var out = acc.querySelector('[data-pa-acc-info]'); if (!out) return;
      if (acc.hasAttribute('data-pa-klapp')) { klappInfo(acc, out); return; }
      var z = accZaehle(acc), n = z.n, notiz = z.notiz;
      var teile = [];
      if (n) teile.push(n + (n === 1 ? ' Detail ausgewählt' : ' Details ausgewählt'));
      if (notiz) teile.push('Beschreibung vorhanden');
      out.textContent = teile.length ? teile.join(' · ') : (out.dataset.leer || '');
    }
    function accSetze(acc, offen) {
      /* Immer nur ein Bereich je Schritt offen */
      if (offen) {
        var st = acc.closest('.pa__step');
        if (st) alle('[data-pa-acc], [data-pa-klapp]', st).forEach(function (a) { if (a !== acc && a.classList.contains('is-open')) accSetze(a, false); });
      }
      acc.classList.toggle('is-open', offen);
      var k = acc.querySelector('[data-pa-acc-toggle]'), t = acc.querySelector('[data-pa-acc-text]');
      if (k) k.setAttribute('aria-expanded', offen ? 'true' : 'false');
      if (k && t) t.textContent = offen ? k.dataset.zu : k.dataset.auf;
      accInfo(acc);
    }
    function vorschlaegeSetze(box, offen) {
      box.classList.toggle('is-open', offen);
      var k = box.querySelector('[data-pa-vorschlaege-toggle]'), t = box.querySelector('[data-pa-vorschlaege-text]');
      if (k) k.setAttribute('aria-expanded', offen ? 'true' : 'false');
      if (k && t) t.textContent = offen ? k.dataset.zu : k.dataset.auf;
    }
    /* Beim Betreten des Schritts nur die Kurzinfos auffrischen – alle Kategorien starten zu */
    function accStart() {
      alle('[data-pa-acc]', form).forEach(function (a) { if (!a.hidden) accInfo(a); });
    }
    /* „Weiter“ heißt im Detailschritt „Überspringen“, solange nichts eingetragen ist */
    function weiterText() {
      if (!el.next) return;
      var txt = el.next.firstChild && el.next.firstChild.nodeType === 3 ? el.next.firstChild : null;
      if (!txt) return;
      if (!el.next.dataset.text) el.next.dataset.text = txt.textContent;
      var st = steps[index], t = st.dataset.paWeiter || el.next.dataset.text;
      if (st.dataset.paStep === 'details' && detailsLeer()) t = cfg.skipWeiter || 'Überspringen';
      txt.textContent = t;
    }

    /* Vor der ersten Auswahl zählt der Detailschritt mit — sonst sprang die
       Anzeige von „Schritt 1 von 3“ auf „Schritt 2 von 4“. */
    function aktiv(step) {
      if (step.dataset.paStep !== 'details') return true;
      if (!gewaehlt().length) return true;
      return syncDetails() > 0;
    }
    function aktiveSchritte() { return steps.filter(aktiv); }
    function stepIndex(name) { for (var i = 0; i < steps.length; i++) if (steps[i].dataset.paStep === name) return i; return -1; }

    /* ---------- Fehleranzeige ---------- */
    function setError(f, text) {
      var box = f.closest('.pa__field') || f.closest('.pa__group');
      var out = box ? box.querySelector('.pa__field-error') : null;
      if (text) f.setAttribute('aria-invalid', 'true'); else f.removeAttribute('aria-invalid');
      if (out) {
        out.textContent = text || '';
        if (!out.id) out.id = 'PaErr' + Math.random().toString(36).slice(2, 8);
        if (text) f.setAttribute('aria-describedby', out.id); else f.removeAttribute('aria-describedby');
      }
    }
    function stepError(step, text) {
      var out = step.querySelector('[data-pa-step-error]');
      if (out) out.textContent = text || '';
      else if (el.msg) el.msg.textContent = text || '';
    }
    function clearErrors(step) {
      alle('[aria-invalid]', step).forEach(function (f) { setError(f, ''); });
      alle('.pa__field-error', step).forEach(function (x) { x.textContent = ''; });
      if (el.msg) { el.msg.textContent = ''; el.msg.classList.remove('is-info'); }
    }

    /* ---------- Prüfung je Schritt ---------- */
    function pruefe(step, still) {
      if (!still) clearErrors(step);
      var name = step.dataset.paStep, fehler = [];
      function mangel(f, text) { fehler.push({ f: f, text: text }); }
      if (name === 'anlass' && !anlass()) fehler.push({ text: cfg.errorAnlass || 'Bitte wählen Sie aus, was bei Ihnen ansteht.' });
      if (name === 'bedarf' && !gewaehlt().length) fehler.push({ text: cfg.errorNeed || 'Bitte wählen Sie mindestens einen Bereich aus.' });
      if (name === 'rahmen' && nurAnderes()) {
        var n = feld('nachricht');
        if (n && !n.value.trim()) mangel(n, n.dataset.paError || 'Bitte beschreiben Sie kurz, was Sie planen.');
      }
      if (name === 'kontakt') {
        var nf = feld('name'), mf = feld('email'), tf = feld('telefon');
        var mail = mf ? mf.value.trim() : '', tel = tf ? tf.value.trim() : '';
        /* E-Mail ist Pflicht, Telefon und Adresse sind optional */
        if (nf && !nf.value.trim()) mangel(nf, nf.dataset.paError);
        if (mf && !mail) mangel(mf, mf.dataset.paErrorLeer || 'Bitte geben Sie Ihre E-Mail-Adresse an.');
        else if (mail && core && !core.emailOk(mail)) mangel(mf, mf.dataset.paError);
        if (tel && core && !core.telefonOk(tel)) mangel(tf, 'Bitte prüfen Sie die Telefonnummer.');
      }
      if (name === 'uebersicht') {
        var c = feld('datenschutz');
        if (c && c.required && !c.checked) mangel(c, c.dataset.paError || 'Bitte bestätigen Sie den Datenschutzhinweis.');
      }
      if (!still) {
        fehler.forEach(function (x) {
          if (x.gruppe && el.kontaktFehler) { el.kontaktFehler.textContent = x.text; return; }
          var k = x.f && klappVon(x.f); if (k) accSetze(k, true);
          if (x.f) setError(x.f, x.text); else stepError(step, x.text);
        });
        if (fehler.length) {
          var erstes = fehler.filter(function (x) { return x.f; })[0];
          if (erstes) erstes.f.focus({ preventScroll: false });
          if (core) fehler.forEach(function (x) { core.track('picura_form_error', { form_id: formId, step_name: name, field: x.f ? (x.f.name || '') : 'auswahl' }); });
        }
      }
      return !fehler.length;
    }

    /* ---------- Auswahl als Kurztext (Rückruf, Fortsetzen) ---------- */
    function auswahlText() {
      var teile = [];
      var a = anlass(); if (a) teile.push(a.value);
      gewaehlt().forEach(function (x) { teile.push(x.dataset.paLabel || x.value); });
      return teile.join(', ');
    }

    /* ---------- Zusammenfassung (letzter Schritt) ---------- */
    function zeilen() {
      var out = [];
      var a = anlass(); if (a) out.push({ label: 'Anlass', wert: a.value, ziel: 'anlass' });
      if (!cfg.productMode) {
        var n = gewaehlt().map(function (x) { return x.dataset.paLabel || x.value; });
        if (n.length) out.push({ label: cfg.summaryNeed || 'Bereiche', wert: n.join(', '), ziel: 'bedarf' });
      } else if (cfg.product) out.push({ label: 'Produkt', wert: cfg.product, ziel: '' });
      var details = {};
      alle('[data-pa-for]:not([hidden]) [data-pa-extra]', form).forEach(function (f) {
        if ((f.type === 'radio' || f.type === 'checkbox') && !f.checked) return;
        var v = (f.value || '').trim(); if (!v) return;
        var b = f.dataset.paBereich || '';
        (details[b] = details[b] || []).push(f.dataset.paExtra + ': ' + v);
      });
      Object.keys(details).forEach(function (b) { out.push({ label: b, wert: details[b].join(' · '), ziel: 'details' }); });
      [['feld_wunschtermin', 'Termin'], ['feld_termin_datum', 'Datum'], ['feld_leistungen', 'Service'], ['feld_aufmass', 'Wunsch'], ['feld_budget', 'Budget'], ['feld_ort', 'PLZ / Ort'], ['feld_dateien', 'Dateien']].forEach(function (p) {
        var v = wert(p[0]);
        if (p[0] === 'feld_termin_datum' && v) v = v.split('-').reverse().join('.');
        if (v) out.push({ label: p[1], wert: v, ziel: 'rahmen' });
        /* Richtwert direkt unter dem Budget – ohne Stift, nicht änderbar */
        if (p[0] === 'feld_budget') {
          var pr = preisSumme();
          if (cfg.showPrices && pr.von > 0) out.push({ label: 'Richtwert', wert: spanne(pr.von, pr.bis) + ' netto, unverbindlich' + (pr.unbekannt ? ' (zzgl. weiterer Bereiche nach Absprache)' : ''), ziel: '', fest: true });
        }
      });
      var msgF = feld('nachricht');
      if (msgF && msgF.value.trim()) out.push({ label: 'Ihre Nachricht', wert: msgF.value.trim().slice(0, 140) + (msgF.value.trim().length > 140 ? ' …' : ''), ziel: 'rahmen' });
      return out;
    }
    var STIFT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z"/></svg>';
    function karte(titel, reihen) {
      var box = document.createElement('div');
      box.className = 'pa__ue-karte';
      var h = document.createElement('p'); h.className = 'pa__ue-titel'; h.textContent = titel; box.appendChild(h);
      var dl = document.createElement('dl'); dl.className = 'pa__ue-liste';
      reihen.forEach(function (r) {
        var zeile = document.createElement('div'); zeile.className = 'pa__ue-zeile';
        var dt = document.createElement('dt'); dt.textContent = r.label;
        var dd = document.createElement('dd'); dd.textContent = r.wert;
        if (r.leer) dd.className = 'is-leer';
        if (r.fest) zeile.classList.add('is-fest');
        zeile.appendChild(dt); zeile.appendChild(dd);
        if (r.ziel && stepIndex(r.ziel) > -1) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'pa__stift'; b.dataset.paGoto = r.ziel;
          b.setAttribute('aria-label', r.label + ' bearbeiten');
          b.title = 'Bearbeiten';
          b.innerHTML = STIFT;
          zeile.appendChild(b);
        }
        dl.appendChild(zeile);
      });
      box.appendChild(dl);
      return box;
    }
    function zusammenfassung() {
      if (!el.uebersicht) return;
      el.uebersicht.innerHTML = '';
      var projekt = zeilen();
      if (projekt.length) el.uebersicht.appendChild(karte('Ihr Projekt', projekt));
      var weg = wunschweg(), mail = wert('email'), tel = wert('telefon');
      var kontaktReihen = [{ label: 'Name', wert: wert('name'), ziel: 'kontakt' }];
      if (wert('unternehmen')) kontaktReihen.push({ label: 'Firma', wert: wert('unternehmen'), ziel: 'kontakt' });
      kontaktReihen.push({ label: 'E-Mail', wert: mail || 'nicht angegeben', leer: !mail, ziel: 'kontakt' });
      kontaktReihen.push({ label: 'Telefon', wert: tel || 'nicht angegeben', leer: !tel, ziel: 'kontakt' });
      if (adresse()) kontaktReihen.push({ label: 'Adresse', wert: adresse(), ziel: 'kontakt' });
      el.uebersicht.appendChild(karte('Ihre Kontaktdaten', kontaktReihen));
    }

    /* ---------- Empfehlung (Branchen-Check) ---------- */
    function paketVorschlag() {
      var a = anlass();
      if (a && a.dataset.paPaket === 'ohne') return null;
      var key = a && a.dataset.paPaket && a.dataset.paPaket !== 'keins' ? a.dataset.paPaket : '';
      var n = gewaehlt().length;
      if (!key) key = n >= 5 ? 'premium' : (n >= 3 ? 'business' : 'starter');
      var karte = document.querySelector('[data-pk-paket="' + key + '"]');
      if (!karte) return null;
      var titel = (karte.querySelector('.pk-karte__titel') || {}).textContent || '';
      var preisText = ((karte.querySelector('[data-pk-kartenpreis]') || {}).textContent || '').replace(/[^\d.,]/g, '');
      var preis = parseFloat(preisText.replace(/\./g, '').replace(',', '.')) || 0;
      var budget = wert('feld_budget');
      if (/bis 500/.test(budget) && preis > 500) return null;
      return { key: key, titel: titel.trim(), preis: preisText };
    }
    function empfehlung() {
      if (!el.empfehlung) return;
      var liste = el.empfehlung.querySelector('[data-pa-emp-liste]');
      var summe = el.empfehlung.querySelector('[data-pa-emp-summe]');
      var text = el.empfehlung.querySelector('[data-pa-emp-text]');
      var paket = el.empfehlung.querySelector('[data-pa-emp-paket]');
      liste.innerHTML = '';
      gewaehlt().forEach(function (x) {
        var li = document.createElement('li');
        var s = document.createElement('span'); s.textContent = x.dataset.paLabel || x.value;
        li.appendChild(s);
        var v = parseFloat(x.dataset.paVon) || 0, b = parseFloat(x.dataset.paBis) || 0;
        if (cfg.showPrices && v) { var w = document.createElement('strong'); w.textContent = spanne(v, b); li.appendChild(w); }
        liste.appendChild(li);
      });
      var p = preisSumme();
      summe.textContent = cfg.showPrices && p.von ? 'Richtwert gesamt: ' + spanne(p.von, p.bis) + ' netto*' : '';
      summe.hidden = !summe.textContent;
      var a = anlass();
      text.textContent = a && a.dataset.paEmptext ? a.dataset.paEmptext : '';
      text.hidden = !text.textContent;
      var vor = paketVorschlag();
      paket.innerHTML = '';
      if (vor && cfg.paketText) {
        var link = document.createElement('a');
        link.href = '#paket';
        link.textContent = cfg.paketText.replace('[paket]', vor.titel).replace('[preis]', vor.preis);
        paket.appendChild(link);
        paket.hidden = false;
      } else paket.hidden = true;
      el.empfehlung.hidden = !gewaehlt().length;
    }

    /* ---------- Budget-Stufen passend zur Auswahl ----------
       Vier Stufen über die Richtwert-Spanne der gewählten Bereiche, gerundet,
       plus „Noch offen“. Iman 09.10.2026: „Ihr Budget-Rahmen je nach
       Produktauswahl realistisch einordnen“ — „bis 500 € … über 5.000 €“
       passte weder zu einem Schaufenster noch zu einer Komplettausstattung.
       Ohne Richtwerte bleiben die Stufen aus dem Editor stehen. */
    var budgetBox = root.querySelector('[data-pa-budget]');
    var budgetHinweis = root.querySelector('[data-pa-budget-hinweis]');
    var budgetOriginal = budgetBox ? budgetBox.innerHTML : '';
    function rund(n) {
      var schritt = n < 1000 ? 50 : (n < 5000 ? 100 : 500);
      return Math.max(schritt, Math.round(n / schritt) * schritt);
    }
    /* Richtwert deutlich über den Stufen; zugeklappt steht er in der Kopfzeile, solange kein Budget gewählt ist */
    function budgetRichtwert(p) {
      if (!budgetHinweis) return;
      var an = !!(cfg.showPrices && p.von);
      budgetHinweis.hidden = !an;
      var w = budgetHinweis.querySelector('[data-pa-budget-wert]'), z = budgetHinweis.querySelector('[data-pa-budget-zusatz]');
      if (an && w) w.textContent = spanne(p.von, p.bis) + ' netto';
      if (z) { z.hidden = !(an && p.unbekannt); z.textContent = 'zzgl. weiterer Bereiche ohne Richtwert'; }
      var info = root.querySelector('[data-pa-budget-klapp] [data-pa-acc-info]');
      if (info) {
        if (info.dataset.leerStandard === undefined) info.dataset.leerStandard = info.dataset.leer || '';
        info.dataset.leer = an ? 'Richtwert ' + spanne(p.von, p.bis) + ' netto' : info.dataset.leerStandard;
      }
    }
    function budgetStufen() {
      if (!budgetBox) return;
      var p = preisSumme();
      var vorher = wert('feld_budget');
      budgetRichtwert(p);
      if (!cfg.showPrices || !p.von || p.bis <= p.von) {
        if (budgetBox.dataset.dynamisch) {
          budgetBox.innerHTML = budgetOriginal;
          delete budgetBox.dataset.dynamisch;
          alle('input', budgetBox).forEach(function (x) { x.checked = x.value === vorher; });
        }
        return;
      }
      var a = rund(p.von + (p.bis - p.von) * 0.25);
      var b = rund(p.von + (p.bis - p.von) * 0.6);
      var c = rund(p.bis);
      if (b <= a) b = rund(a * 1.5);
      if (c <= b) c = rund(b * 1.4);
      var stufen = ['bis ' + zahl(a) + ' €', zahl(a) + '–' + zahl(b) + ' €', zahl(b) + '–' + zahl(c) + ' €', 'über ' + zahl(c) + ' €', 'Noch offen'];
      var kennung = stufen.join('|');
      if (budgetBox.dataset.dynamisch !== kennung) {
        var muster = budgetBox.querySelector('input');
        var name = muster ? muster.name : 'feld_budget', extra = muster ? muster.dataset.paExtra : 'Budget';
        budgetBox.innerHTML = '';
        stufen.forEach(function (t) {
          var lab = document.createElement('label'); lab.className = 'pa__chip';
          var inp = document.createElement('input'); inp.type = 'radio'; inp.name = name; inp.value = t; inp.dataset.paExtra = extra;
          if (t === vorher) inp.checked = true;
          var sp = document.createElement('span'); sp.textContent = t;
          lab.appendChild(inp); lab.appendChild(sp); budgetBox.appendChild(lab);
        });
        budgetBox.dataset.dynamisch = kennung;
      }
    }

    /* ---------- Fortschritt ---------- */
    function restzeit(ab) {
      var s = 0;
      aktiveSchritte().forEach(function (st) { if (steps.indexOf(st) > ab) s += parseInt(st.dataset.paSek || '20', 10); });
      if (s <= 0) return 'letzter Schritt';
      if (s < 45) return 'noch wenige Sekunden';
      var m = Math.max(1, Math.round(s / 60));
      return 'noch ca. ' + m + (m === 1 ? ' Minute' : ' Minuten');
    }
    function fortschritt() {
      var akt = aktiveSchritte(), pos = akt.indexOf(steps[index]) + 1, ges = akt.length;
      if (el.status) el.status.textContent = 'Schritt ' + pos + ' von ' + ges + ' · ' + restzeit(index);
      if (el.bars) {
        if (el.bars.children.length !== ges) {
          el.bars.innerHTML = '';
          for (var i = 0; i < ges; i++) el.bars.appendChild(document.createElement('span'));
        }
        Array.prototype.forEach.call(el.bars.children, function (b, k) {
          b.classList.toggle('is-done', k < pos - 1);
          b.classList.toggle('is-active', k === pos - 1);
        });
      }
      return { pos: pos, ges: ges };
    }

    /* ---------- Anzeige ---------- */
    function zeige(i, fokus) {
      index = Math.max(0, Math.min(i, steps.length - 1));
      if (!aktiv(steps[index])) index = Math.min(index + 1, steps.length - 1);
      steps.forEach(function (st, k) { st.classList.toggle('is-active', k === index); st.hidden = k !== index; });
      var akt = aktiveSchritte();
      var erster = akt[0] === steps[index], letzter = akt[akt.length - 1] === steps[index];
      if (el.back) el.back.hidden = erster;
      if (el.next) el.next.hidden = letzter;
      if (el.submit) el.submit.hidden = !letzter;
      if (el.msg && !el.msg.classList.contains('is-info')) el.msg.textContent = '';
      var name = steps[index].dataset.paStep;
      if (name === 'details') accStart();
      if (el.next) el.next.disabled = false;
      var skL = root.querySelector('[data-pa-rahmen-skip]'); if (skL) skL.hidden = true;
      if (name === 'rahmen') {
        budgetStufen();
        var kl = rahmenKlapps();
        kl.forEach(accInfo);
        /* Beim Betreten ist der erste noch nicht grüne Bereich offen */
        if (!kl.some(function (a) { return a.classList.contains('is-open'); })) {
          var erst = kl.filter(function (a) { return !a.classList.contains('is-fertig') && !klappInhalt(a); })[0];
          if (erst) accSetze(erst, true);
        }
        rahmenStand();
      }
      if (name === 'kontakt') vorbelegen();
      if (name === 'uebersicht') { zusammenfassung(); empfehlung(); }
      weiterText();
      root.classList.toggle('is-letzter', letzter);
      var nachMsg = root.querySelector('[data-pa-msg-pflicht]'), optMsg = root.querySelector('[data-pa-msg-optional]');
      if (nachMsg && optMsg) {
        var pfl = nurAnderes(); nachMsg.hidden = !pfl; optMsg.hidden = pfl;
        /* Nur bei „Etwas anderes“ ist die Nachricht Pflicht – dann muss das Feld sichtbar sein */
        var mk = root.querySelector('[data-pa-msg-klapp]');
        if (pfl && mk && name === 'rahmen') accSetze(mk, true);
      }
      var f = fortschritt();
      if (fokus !== false) {
        var head = steps[index].querySelector('.pa__legend, legend');
        if (head) { head.setAttribute('tabindex', '-1'); head.focus({ preventScroll: true }); }
        var card = root.querySelector('.pa__card');
        if (card && card.getBoundingClientRect().top < 0) card.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (core) core.track('picura_form_step', { form_id: formId, step_name: name, step_number: f.pos, step_count: f.ges, selections: gewaehlt().map(function (x) { return x.dataset.paKey; }).join(','), anlass: anlass() ? anlass().value : '' });
      }
      speichern();
      if (core && gestartet) core.fortschritt({ anker: anker ? '#' + anker.id : '', schritt: f.pos, gesamt: f.ges, auswahl: auswahlText() });
    }
    function weiter() {
      if (el.next && el.next.disabled) return; /* z. B. Enter-Taste, solange Schritt 3 nicht fertig ist */
      if (!pruefe(steps[index])) return;
      var z = index + 1;
      while (steps[z] && !aktiv(steps[z])) z++;
      if (steps[z]) zeige(z);
    }
    function zurueck() {
      var z = index - 1;
      while (z > 0 && !aktiv(steps[z])) z--;
      zeige(Math.max(0, z));
    }

    /* Rückruf und WhatsApp brauchen eine Telefonnummer, der Rückruf ein Zeitfenster */
    function wegAnwenden(v) {
      if (el.zeitfenster) el.zeitfenster.hidden = v !== 'Rückruf';
      var pfl = v === 'Rückruf' || v === 'WhatsApp';
      var m = root.querySelector('[data-pa-tel-pflicht]'), o = root.querySelector('[data-pa-tel-opt]');
      if (m) m.hidden = !pfl;
      if (o) o.hidden = pfl;
      if (el.kontaktFehler) el.kontaktFehler.textContent = '';
    }

    /* ---------- Kontakt vorbelegen ---------- */
    function vorbelegen() {
      if (!core) return;
      var k = core.kontakt();
      [['name', k.name], ['email', k.email], ['telefon', k.telefon], ['unternehmen', k.firma]].forEach(function (p) {
        var f = feld(p[0]);
        if (f && !f.value && p[1]) f.value = p[1];
      });
    }

    /* ---------- Zwischenstand ---------- */
    function speichern() {
      try {
        var d = { step: index, values: {}, checked: [] };
        Array.prototype.forEach.call(form.elements, function (f) {
          if ((!f.name && !f.id) || f.type === 'hidden' || f.name === 'website') return;
          if (f.type === 'checkbox' || f.type === 'radio') { if (f.checked) d.checked.push(f.name + '::' + f.value); }
          else if (f.value) d.values[f.id || f.name] = f.value;
        });
        sessionStorage.setItem(storeKey, JSON.stringify(d));
      } catch (e) { /* privater Modus */ }
    }
    function laden() {
      var d = null;
      try { d = JSON.parse(sessionStorage.getItem(storeKey) || 'null'); } catch (e) { d = null; }
      if (!d) return false;
      Array.prototype.forEach.call(form.elements, function (f) {
        if ((!f.name && !f.id) || f.type === 'hidden') return;
        if (f.type === 'checkbox' || f.type === 'radio') { if (d.checked.indexOf(f.name + '::' + f.value) > -1) f.checked = true; }
        else if (d.values[f.id || f.name] !== undefined) f.value = d.values[f.id || f.name];
      });
      return typeof d.step === 'number' ? d.step : 0;
    }

    /* ---------- Vorauswahl über die URL ---------- */
    var params; try { params = new URLSearchParams(location.search); } catch (e) { params = null; }
    function vorauswahl() {
      if (!params) return false;
      var treffer = false;
      var q = params.get('bedarf') || params.get('kategorie') || '';
      if (q) {
        var map = cfg.aliases || {};
        var ziel = (map[q.toLowerCase()] || q).toLowerCase();
        alle('[data-pa-need]', form).forEach(function (x) {
          var label = (x.dataset.paLabel || '').toLowerCase(), key = (x.dataset.paKey || '').toLowerCase();
          if (key === ziel || label.indexOf(ziel) > -1) { x.checked = true; treffer = true; }
        });
      }
      var an = (params.get('anlass') || '').toLowerCase();
      if (an) alle('[data-pa-anlass]', form).forEach(function (x) { if (x.value.toLowerCase().indexOf(an) > -1) x.checked = true; });
      var br = params.get('branche');
      if (br && core) core.kontext({ branche: br });
      return treffer;
    }

    /* ---------- Versand ---------- */
    var versand = core ? core.binden(form, el.iframe, {
      erfolg: function () {
        if (el.submit) el.submit.disabled = false;
        if (el.msg) { el.msg.textContent = ''; el.msg.classList.remove('is-info'); }
        try { sessionStorage.removeItem(storeKey); } catch (e) { /* egal */ }
        var vor = (feld('name') ? feld('name').value : '').trim();
        var t = core.nameTeilen(vor);
        core.kontakt({ name: vor, email: wert('email'), telefon: wert('telefon'), firma: wert('unternehmen') });
        core.fortschritt(null);
        var p = preisSumme();
        core.lead({ lead_id: aktuelleId, form_type: cfg.formType || 'Anfrage', form_id: formId, branche: cfg.branche || '', seite: location.pathname, bereiche: gewaehlt().map(function (x) { return x.dataset.paKey; }).join(','), anlass: anlass() ? anlass().value : '', value: cfg.showPrices && p.von ? p.von : 0, rueckruf: wunschweg() === 'Rückruf', budget_band: wert('feld_budget') });
        fertig(t.vorname);
      },
      fehler: function (text, zeitueber) {
        if (el.submit) el.submit.disabled = false;
        if (el.msg) {
          el.msg.classList.remove('is-info');
          el.msg.textContent = (text && !zeitueber ? text + ' ' : '') + (cfg.errorSend || 'Das hat leider nicht geklappt.');
          var a = document.createElement('a');
          a.href = core.mailto(cfg.empfaenger || 'anfrage@picura.de', 'Anfrage ' + aktuelleId, (feld('nachricht') && form.querySelector('input[type="hidden"][name="nachricht"]') || {}).value || auswahlText());
          a.textContent = ' Per E-Mail senden';
          el.msg.appendChild(a);
        }
        core.track('picura_form_fail', { form_id: formId, reason: zeitueber ? 'timeout' : 'server' });
      }
    }) : null;

    function fertig(vorname) {
      root.classList.add('is-done');
      if (!el.done) return;
      var titel = el.done.querySelector('[data-pa-done-titel]');
      if (titel) {
        var v = titel.dataset.vorlage || titel.textContent;
        titel.textContent = vorname ? v.replace('[vorname]', vorname) : v.replace(', [vorname]', '').replace(' [vorname]', '');
      }
      var idEl = el.done.querySelector('[data-pa-done-id]');
      if (idEl && aktuelleId) { idEl.textContent = 'Ihre Anfragenummer: ' + aktuelleId; idEl.hidden = false; }
      var ant = el.done.querySelector('[data-pa-done-antwort]');
      if (ant && (cfg.antwortHeute || cfg.antwortMorgen)) {
        var d = new Date(), werktag = d.getDay() > 0 && d.getDay() < 6;
        ant.textContent = werktag && d.getHours() < (cfg.antwortBis || 15) ? cfg.antwortHeute : cfg.antwortMorgen;
        ant.hidden = !ant.textContent;
      }
      var mail = el.done.querySelector('[data-pa-done-mail]');
      if (mail && core) mail.href = core.mailto(cfg.empfaenger || 'anfrage@picura.de', 'Dateien zu Anfrage ' + aktuelleId, 'Hallo Picura-Team,\n\nanbei die Dateien zu meiner Anfrage ' + aktuelleId + '.\n\n');
      el.done.classList.add('is-active');
      el.done.setAttribute('tabindex', '-1');
      el.done.focus({ preventScroll: true });
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function nachrichtText() {
      var nf = feld('name'), weg = wunschweg();
      var mail = wert('email'), tel = wert('telefon');
      var kontakt = ['Name: ' + (nf ? nf.value.trim() : '')];
      if (wert('unternehmen')) kontakt.push('Firma: ' + wert('unternehmen'));
      kontakt.push('E-Mail: ' + (mail || 'nicht angegeben – bitte telefonisch melden'));
      kontakt.push('Telefon: ' + (tel || 'nicht angegeben'));
      if (adresse()) kontakt.push('Adresse: ' + adresse());
      var projekt = [];
      if (cfg.product) projekt.push('Produkt: ' + cfg.product);
      var details = {};
      alle('[data-pa-for]:not([hidden]) [data-pa-extra]', form).forEach(function (f) {
        if ((f.type === 'radio' || f.type === 'checkbox') && !f.checked) return;
        var v = (f.value || '').trim(); if (!v) return;
        (details[f.dataset.paBereich || ''] = details[f.dataset.paBereich || ''] || []).push(f.dataset.paExtra + ': ' + v);
      });
      gewaehlt().forEach(function (x) {
        var t = x.dataset.paLabel || x.value;
        projekt.push('• ' + t + (details[t] ? ' – ' + details[t].join(' · ') : ''));
      });
      var rahmen = [];
      [['feld_wunschtermin', 'Termin'], ['feld_termin_datum', 'Datum'], ['feld_leistungen', 'Leistungen'], ['feld_aufmass', 'Wunsch'], ['feld_budget', 'Budget'], ['feld_ort', 'PLZ / Ort'], ['feld_dateien', 'Dateien']].forEach(function (p) {
        var v = wert(p[0]);
        if (p[0] === 'feld_termin_datum' && v) v = v.split('-').reverse().join('.');
        if (v) rahmen.push(p[1] + ': ' + v);
      });
      var p = preisSumme(), richt = [];
      if (cfg.showPrices && p.von) richt.push(spanne(p.von, p.bis) + ' netto' + (p.unbekannt ? ' (zzgl. weiterer Bereiche)' : ''));
      if (check) {
        var vor = paketVorschlag();
        if (vor) richt.push('Paket-Vorschlag: ' + vor.titel + ' ab ' + vor.preis + ' € netto');
      }
      var msgF = feld('nachricht');
      var kopf = (check ? 'BRANCHEN-CHECK' : (cfg.productMode ? 'PRODUKT-ANFRAGE' : 'PROJEKT-ANFRAGE')) + ' · ' + aktuelleId + ' · ' + (cfg.branche || cfg.product || cfg.context || '') + ' (' + location.pathname + ')';
      var akt = aktiveSchritte();
      return core.nachricht(kopf, [
        { titel: 'KONTAKT', zeilen: kontakt },
        { titel: 'ANLASS', zeilen: anlass() ? [anlass().value] : [] },
        { titel: 'PROJEKT', zeilen: projekt },
        { titel: 'TERMIN & SERVICE', zeilen: rahmen },
        { titel: 'RICHTWERT LAUT WEBSITE', zeilen: richt },
        { titel: 'NACHRICHT', zeilen: msgF && msgF.value.trim() ? [msgF.value.trim()] : [] },
        { titel: 'HERKUNFT', zeilen: core.herkunftZeilen({ schritte: akt.length, dauer: ersteEingabe ? Date.now() - ersteEingabe : 0 }) }
      ]);
    }

    form.addEventListener('submit', function (e) {
      var honig = form.querySelector('.pa__honeypot');
      if (honig && honig.value) { e.preventDefault(); return; }
      var akt = aktiveSchritte();
      for (var i = 0; i < akt.length; i++) {
        if (!pruefe(akt[i], true)) { e.preventDefault(); zeige(steps.indexOf(akt[i])); pruefe(akt[i]); return; }
      }
      if (!core) return; /* ohne Kern: normaler Versand der sichtbaren Felder */
      if (ersteEingabe && Date.now() - ersteEingabe < 3000) {
        e.preventDefault();
        setTimeout(function () { if (form.requestSubmit) form.requestSubmit(el.submit); else form.submit(); }, 3100 - (Date.now() - ersteEingabe));
        return;
      }
      alle('[data-pa-platzhalter]', form).forEach(function (x) { x.parentNode.removeChild(x); });
      aktuelleId = core.leadId();
      var nf = feld('name'), mf = feld('email'), tf = feld('telefon'), msgF = feld('nachricht');
      var t = core.nameTeilen(nf ? nf.value : '');
      function platz(name, v) { var x = core.versteckt(form, name, v); x.setAttribute('data-pa-platzhalter', ''); return x; }
      platz('vorname', t.vorname);
      platz('nachname', t.nachname);
      if (mf && !mf.value.trim()) { mf.disabled = true; platz('email', core.FEHLT); }
      if (tf && !tf.value.trim()) { tf.disabled = true; platz('telefon', core.FEHLT); }
      platz('phone', core.fehlend(tf ? tf.value : ''));
      var text = nachrichtText();
      if (msgF) msgF.disabled = true;
      platz('nachricht', text);
      platz('message', text);
      platz('lead_id', aktuelleId);
      platz('seite', location.pathname);
      core.herkunftFelder(form);
      alle('[data-pa-extra]', form).forEach(function (f) {
        if (f.type === 'radio' || f.type === 'checkbox') return;
        if (!f.value.trim() && f.name && f.name.indexOf('feld_') === 0) f.disabled = true;
      });
      if (el.msg) { el.msg.classList.add('is-info'); el.msg.textContent = 'Wird gesendet …'; }
      if (el.submit) el.submit.disabled = true;
      speichern();
      versand.gesendet();
      setTimeout(function () {
        alle('[disabled]', form).forEach(function (f) {
          if (f === el.submit) return;
          var g = f.closest('[data-pa-for]');
          if (g && g.hidden) return;
          f.disabled = false;
        });
      }, 0);
    });

    /* ---------- Ereignisse ---------- */
    if (el.next) el.next.addEventListener('click', weiter);
    if (el.back) el.back.addEventListener('click', zurueck);
    form.addEventListener('pointerdown', function (e) {
      letzterZeiger = Date.now();
      /* Optionale Auswahl (Schritt 2 und 3): erneuter Klick auf eine gewählte Option hebt die Wahl auf.
         Der Zustand wird vor dem Klick gemerkt, weil der Klick das Radio sonst schon setzt. */
      var chip = e.target.closest('[data-pa-vorschlaege] .pa__chip, [data-pa-klapp] .pa__chip');
      var r = chip && chip.querySelector('input[type="radio"]');
      if (r) r.dataset.war = r.checked ? '1' : '';
    });
    form.addEventListener('click', function (e) {
      var r = e.target;
      if (!r.matches || !r.matches('[data-pa-vorschlaege] input[type="radio"], [data-pa-klapp] input[type="radio"]') || r.dataset.war !== '1') return;
      r.dataset.war = '';
      r.checked = false;
      r.dispatchEvent(new Event('change', { bubbles: true }));
    });
    function erste() {
      if (!ersteEingabe) ersteEingabe = Date.now();
      if (!gestartet) {
        gestartet = true;
        if (core) core.track('picura_form_start', { form_id: formId, entry: (params && params.get('quelle')) || (params && (params.get('bedarf') || params.get('anlass')) ? 'url_param' : 'direkt') });
      }
    }
    form.addEventListener('focusin', erste);
    form.addEventListener('change', function (e) {
      erste();
      var t = e.target;
      if (t.matches('[data-pa-need]')) { syncDetails(); stepError(steps[index], ''); }
      if (klappVon(t)) { accInfo(klappVon(t)); weiterText(); rahmenStand(); }
      if (t.name === 'feld_wunschtermin' && el.datum) el.datum.hidden = !(t.checked && t.value === cfg.festerTermin);
      if (t.name === 'feld_wunschweg') wegAnwenden(t.value);
      if (t.matches('[data-pa-anlass]')) {
        stepError(steps[index], '');
        if (Date.now() - letzterZeiger < 800) setTimeout(weiter, 260);
      }
      speichern();
    });
    form.addEventListener('input', function (e) {
      erste();
      if (e.target.getAttribute('aria-invalid')) setError(e.target, '');
      if ((e.target.name === 'email' || e.target.name === 'telefon') && el.kontaktFehler) el.kontaktFehler.textContent = '';
      if (klappVon(e.target)) { accInfo(klappVon(e.target)); weiterText(); rahmenStand(); }
      speichern();
    });
    var mailF = feld('email');
    if (mailF && el.vorschlag && core) mailF.addEventListener('blur', function () {
      var v = core.emailVorschlag(mailF.value);
      el.vorschlag.hidden = !v;
      if (!v) return;
      el.vorschlag.innerHTML = '';
      el.vorschlag.appendChild(document.createTextNode('Meinten Sie '));
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'pa__linkknopf'; b.textContent = v;
      b.addEventListener('click', function () { mailF.value = v; el.vorschlag.hidden = true; speichern(); });
      el.vorschlag.appendChild(b);
      el.vorschlag.appendChild(document.createTextNode('?'));
    });
    /* Enter in einem Feld führt vor dem letzten Schritt zu „Weiter“, nicht zum Absenden */
    form.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' || e.target.tagName === 'TEXTAREA' || e.target.tagName === 'BUTTON') return;
      var akt = aktiveSchritte();
      if (akt[akt.length - 1] !== steps[index]) { e.preventDefault(); weiter(); }
    });
    root.addEventListener('click', function (e) {
      var g = e.target.closest('[data-pa-goto]');
      if (g) { var i = stepIndex(g.dataset.paGoto); if (i > -1) zeige(i); return; }
      if (e.target.closest('[data-pa-rahmen-skip]')) {
        rahmenKlapps().forEach(function (a) { a.classList.add('is-fertig'); accSetze(a, false); });
        rahmenStand();
        weiter();
        return;
      }
      var kw = e.target.closest('[data-pa-klapp-weiter]');
      if (kw) { klappWeiter(klappVon(kw)); return; }
      var accK = e.target.closest('[data-pa-acc-toggle]');
      if (accK) { var acc = klappVon(accK); accSetze(acc, !acc.classList.contains('is-open')); return; }
      var vk = e.target.closest('[data-pa-vorschlaege-toggle]');
      if (vk) { var box = vk.closest('[data-pa-vorschlaege]'); vorschlaegeSetze(box, !box.classList.contains('is-open')); return; }
      if (e.target.closest('[data-pa-skip]')) { var z = index + 1; while (steps[z] && !aktiv(steps[z])) z++; if (steps[z]) zeige(z); return; }
      if (e.target.closest('[data-pa-restart]')) {
        form.reset();
        alle('[disabled]', form).forEach(function (f) { f.disabled = false; });
        alle('[data-pa-platzhalter]', form).forEach(function (x) { x.parentNode.removeChild(x); });
        alle('[data-pa-klapp]', form).forEach(function (a) { a.classList.remove('is-fertig'); accSetze(a, false); });
        root.classList.remove('is-done');
        if (el.done) el.done.classList.remove('is-active');
        ersteEingabe = 0;
        syncDetails();
        vorbelegen();
        zeige(0);
      }
    });

    /* Sichtbarkeit für das Tracking: einmal, sobald die Hälfte im Bild ist */
    if (core && 'IntersectionObserver' in window) {
      var gesehen = false;
      var io = new IntersectionObserver(function (en) {
        if (gesehen || !en[0].isIntersecting) return;
        gesehen = true; io.disconnect();
        core.track('picura_form_view', { form_id: formId, branche: cfg.branche || '', seite: location.pathname });
      }, { threshold: 0.4 });
      io.observe(root.querySelector('.pa__card') || root);
    }

    /* Schnellstart von außen (Hero-Chips u. a.): Bereich wählen, direkt weiter */
    root._paWaehle = function (key) {
      var hit = false;
      alle('[data-pa-need]', form).forEach(function (x) { if ((x.dataset.paKey || '').toLowerCase() === String(key).toLowerCase()) { x.checked = true; hit = true; } });
      if (!hit) return false;
      erste();
      syncDetails();
      var b = stepIndex('bedarf');
      var z = b + 1;
      while (steps[z] && !aktiv(steps[z])) z++;
      zeige(steps[z] ? z : b);
      return true;
    };

    /* ---------- Start ---------- */
    if (core && cfg.branche) core.kontext({ branche: cfg.branche });
    var geladen = laden();
    /* Stufen erst nach dem Laden der Bereiche bauen, dann den gespeicherten
       Budget-Wert ein zweites Mal setzen — er gehört zu den dynamischen Stufen. */
    budgetStufen();
    if (geladen !== false) laden();
    var vor = vorauswahl();
    syncDetails();
    /* Ohne JS ist alles offen; mit JS starten Kategorien und Vorschläge zugeklappt */
    alle('[data-pa-acc], [data-pa-klapp]', form).forEach(function (a) { accSetze(a, false); });
    alle('[data-pa-vorschlaege]', form).forEach(function (b) { vorschlaegeSetze(b, false); });
    var start = 0;
    if (vor) { var bi = stepIndex('bedarf'); start = bi + 1; while (steps[start] && !aktiv(steps[start])) start++; }
    else if (geladen !== false && geladen > 0) start = Math.min(geladen, steps.length - 1);
    var we = root.querySelector('input[name="feld_wunschweg"]:checked');
    wegAnwenden(we ? we.value : 'E-Mail');
    var wt = root.querySelector('input[name="feld_wunschtermin"]:checked');
    if (wt && el.datum) el.datum.hidden = wt.value !== cfg.festerTermin;
    zeige(start, false);
  }

  /* ---------- Sprungmarken ----------
     Links wie „Jetzt Anfrage stellen“ holen die Formular-Karte ins Bild; eine
     klebende Kopfzeile wird beim Klick gemessen und abgezogen. */
  function headerOffset() {
    var found = 0;
    document.querySelectorAll('.shopify-section-group-header-group, .pch, header, .header, .announcement-bar').forEach(function (h) {
      var pos = getComputedStyle(h).position;
      if (pos !== 'sticky' && pos !== 'fixed') return;
      var box = h.getBoundingClientRect();
      if (box.bottom <= 0 || box.top > 160 || box.height < 20) return;
      if (box.bottom > found) found = box.bottom;
    });
    return Math.min(found, 200);
  }
  function scrollToAnfrage(section) {
    var card = section.querySelector('.pa__card');
    var off = headerOffset() + 12;
    var top = window.pageYOffset + (card || section).getBoundingClientRect().top - off;
    var smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: Math.max(0, Math.round(top)), behavior: smooth ? 'smooth' : 'auto' });
  }
  function sectionForHash(hash) {
    if (!hash || hash.length < 2) return null;
    var t;
    try { t = document.getElementById(decodeURIComponent(hash.slice(1))); } catch (e) { t = null; }
    return t && t.closest ? t.closest('.picura-anfrage') : null;
  }
  document.addEventListener('click', function (e) {
    /* Schnellstart: <a data-pa-bedarf="fahrzeug" href="/?bedarf=fahrzeug#projekt-anfrage"> */
    var chip = e.target.closest ? e.target.closest('[data-pa-bedarf]') : null;
    if (chip) {
      var root = document.querySelector('.picura-anfrage [data-pa-root]');
      if (root && root._paWaehle && root._paWaehle(chip.getAttribute('data-pa-bedarf'))) {
        e.preventDefault();
        scrollToAnfrage(root.closest('.picura-anfrage'));
        return;
      }
    }
    var link = e.target.closest ? e.target.closest('a[href]') : null;
    if (!link || link.target === '_blank') return;
    var href = link.getAttribute('href') || '';
    var hash = href.indexOf('#') > -1 ? href.slice(href.indexOf('#')) : '';
    if (!hash) return;
    var path = href.slice(0, href.indexOf('#'));
    if (path && path !== location.pathname && path !== location.pathname + location.search) return;
    var section = sectionForHash(hash);
    if (!section) return;
    e.preventDefault();
    scrollToAnfrage(section);
    if (history.replaceState) history.replaceState(null, '', hash);
  });
  function fixHash() {
    var section = sectionForHash(location.hash);
    if (section) setTimeout(function () { scrollToAnfrage(section); }, 60);
  }

  function boot() { document.querySelectorAll('.pa[data-pa-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('load', fixHash);
  document.addEventListener('shopify:section:load', boot);
})();
